import React from 'react';
import '../styles/FullScreenLoader.css';

const FullScreenLoader = () => (
  <div className="full-screen-loader">
    <div className="full-screen-loader-text">Loading Application...</div>
  </div>
);

export default FullScreenLoader;
